import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { logotypeParallax } from './header'
gsap.registerPlugin(ScrollTrigger)

export const once = namespace => {
	logo(namespace)
	headerFade()
	shutter()
}

const logo = namespace => {

	let logo = document.querySelector('[data-animation="header-logo"]')

	if (!logo) return

	let icon = logo.querySelectorAll('[data-el="header-logo-icon"]'),
		logotype = logo.querySelector('[data-el="header-logotype"]')

	logo.style.opacity = 1

	if (namespace == 'homepage' && window.innerWidth > 782) {
		gsap.fromTo(logo, {
			y: window.innerHeight * 0.4,
			scale: 1.5,
		}, {
			y: 0,
			scale: 1,
			duration: 1.4,
			ease: 'power2.inOut',
			delay: 1.8,
		})
	}

	gsap.fromTo(icon, {
		strokeDashoffset: 1000,
	}, {
		strokeDashoffset: 0,
		duration: 2.2,
		ease: 'power3.out',
		delay: 0.3,
	})

	gsap.fromTo(logotype, {
		y: '100%',
	}, {
		y: 0,
		duration: 1,
		ease: 'power3.out',
		delay: 0.3,
		onComplete: () => {
			logotypeParallax()
		},
	})

}

const headerFade = () => {

	let els = document.querySelectorAll('[data-animation="header-fade"]')

	if (!els.length) return

	els.forEach(el => {
		el.style.opacity = 1
	})

	gsap.fromTo(els, {
		opacity: 0,
	}, {
		opacity: 1,
		duration: 0.6,
		delay: 1,
	})
}

const shutter = () => {

	let el = document.querySelector('[data-animation="home-banner-shutter"]')

	if (!el) return

	el.style.opacity = 1

	gsap.fromTo(el, {
		scaleY: 0,
	}, {
		scaleY: 1,
		duration: 1.4,
		ease: 'power2.inOut',
		delay: 1.8,
	})

}

export default () => { }